<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/K8lDuN/tc-custom/9781788786584-1600.jpg?1685204506697?1725649950006" alt="This image is the cover for the book Toot's Tales"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Toot's Tales
      </h1>
      <p class="bookDescription body article font2">
        <p>‘I have decided to put my poems in a book So all the world can take a look, But I’ve been looking over all I’ve done And boy oh boy it was all such fun.’ (From ‘Poetry in Motion’) The poems in this book by Jacquie Large (‘TOOT’) are all fun poems. Some will make you laugh and some, perhaps, will make you think. But most of all Jacquie wants you to enjoy them.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jacqueline Northmore Large
      </h2>
      
      <p class="authorDescription body article">Jacquie Large (TOOT) loves poems, stories, and anything that will make you smile. Her poems, especially, are about her take on life, the fun and drama along the way. Her poems have sometimes made it into her local paper The Border Post, and last year she ran a poetry class at her local art gallery. Her poems are fun, light-hearted and tricky. Some of them have happened to her and this makes them special!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?117da54a